module.exports = __webpack_public_path__ + "assets/u104.8f6b580d.svg";